"use client"

// Mirrors app/editor/passwordStorage.ts under its own key — ANALYTICS_PASSWORD
// and the editor password are separate credentials that may diverge.

const PASSWORD_STORAGE_KEY = 'analyticsPassword'

// Read the previously-accepted analytics password from localStorage so the
// dashboard doesn't re-prompt across tabs and sessions.
export const readStoredPassword = (): string | null => {
  if (typeof window === 'undefined') return null
  return localStorage.getItem(PASSWORD_STORAGE_KEY)
}

// Persist the password after a successful fetch so reloads skip the gate.
export const writeStoredPassword = (password: string) => {
  if (typeof window === 'undefined') return
  localStorage.setItem(PASSWORD_STORAGE_KEY, password)
}

// Drop the stored password after the server returns 401, so the next visit
// re-prompts instead of silently re-failing with the same bad password.
export const clearStoredPassword = () => {
  if (typeof window === 'undefined') return
  localStorage.removeItem(PASSWORD_STORAGE_KEY)
}
